import { Avatar } from '@mui/material';
import styled from 'styled-components';


export const ImageWrapper = styled('div')(({ theme }) => `
  width: 75px;
  height: 75px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #918EFA;
`);
export const StyledAvatar = styled(Avatar)(({ theme }) => `
  width: 65px !important;
  height: 65px !important;
`);
